module.exports = __webpack_public_path__ + "static/img/12-01.10853ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12-01.png
// module id = Q4p+
// module chunks = 0